import PageAliasMapping from './PageAliasMapping';
import NissanPageAliasMapping from './NissanPageAliasMapping';
import GMPageAliasMapping from './GMPageAliasMapping';

export default {
	PageAliasMapping,
	NissanPageAliasMapping,
	GMPageAliasMapping
};
